import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-homethirteen-main-banner',
  templateUrl: './homethirteen-main-banner.component.html',
  styleUrls: ['./homethirteen-main-banner.component.scss']
})
export class HomethirteenMainBannerComponent implements OnInit {

  backgroundImages = [
    'assets/img/main-banner3.jpg',
    'assets/img/main-banner4.jpg',
    'assets/img/main-banner5.jpg',
    'assets/img/main-banner1.jpg',
    'assets/img/main-banner2.jpg'
  ];

  contentSlides = [
    { title: 'FMCET is Now Autonomous', description: 'Recognized by UGC & NAAC A+ Accredited' },
    { title: 'Empowering Engineers', description: 'Future-Ready Curriculum and Placements' },
    { title: 'Advanced Labs & Facilities', description: 'World-class Infrastructure' },
    { title: 'Top Recruiters', description: 'Assured Placements and Career Support' },
    { title: 'Admissions Open 2025', description: 'Apply Now for UG & PG Programs' }
  ];

  backgroundCarouselOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    items: 1,
    dots: false,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn'
  };

contentCarouselOptions = {
  loop: true,
  margin: 10,
  items: 1,
  dots: true,
  nav: false,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
};

  constructor() {}

  ngOnInit(): void {}
}
